export default {
    ACTOR_ID: {
        CAMPFIRE: "campfire"
    },

    ACTOR_ANIMATION_DIR: {
        NONE: 0,
        UP: 1,
        DOWN: 2,
        LEFT: 3,
        RIGHT: 4
    },

    DEFAULT_LEVEL_ID: "forest_clearing",

    ITEM_ID: {
        ACORN: "acorn",
        BLUE_FLOWERS: "blue_flowers",
        BLACK_SPOTTED_MUSHROOMS: "black_spotted_mushroom",
        BUCKET: "bucket",
        BEETROOT_SEEDS: "beetroot_seeds",
        BRASS_BELL: "brass_bell",
        CLEANING_CLOTH: "cleaning_cloth",
        CLEANING_FLUID: "cleaning_fluid",
        CORN_SEEDS: "corn_seeds",
        COURGETTE_SEEDS: "courgette_seeds",
        COLLECTION_JAR_BLUE_FLOWERS_EMPTY: "collection_jar_blue_flowers_empty",
        COLLECTION_JAR_TRUFFLES_FULL: "collection_jar_truffles_full",
        COLLECTION_JAR_BLUE_FLOWERS_FULL: "collection_jar_blue_flowers_full",
        COLLECTION_JAR_PINK_FLOWERS_FULL: "collection_jar_pink_flowers_full",
        COLLECTION_JAR_BLACK_SPOTTED_MUSHROOMS_FULL: "collection_jar_black_spotted_mushrooms_full",
        COLLECTION_JAR_TURNIP_TOPS_FULL: "collection_jar_turnip_tops_full",
        DAISY_FLOWERS: "daisy_flowers",
        DAMSEL_DRESS: "damsel_dress",
        EMPTY_MUG_1: "empty_mug_1",
        EMPTY_MUG_2: "empty_mug_2",
        EMPTY_MUG_3: "empty_mug_3",
        GOLDEN_NUT: "golden_nut",
        GOLDEN_TURNIP: "golden_turnip",
        GOLDEN_COIN: "gold_coin",
        HEALTH_TURNIP: "health_turnip",
        ROYAL_CLOAK: "royal_cloak",
        ROYAL_TRUFFLE_LOCATOR: "royal_truffle_locator",
        ROYAL_SVAN_MIRROR: "royal_mirror",
        MOP: "mop",
        PRINCE_SVANS_TROUSERS: "prince_svans_trousers",
        PRIZED_CORN: "prized_corn",
        PRIZED_COURGETTE: "prized_courgette",
        PRIZED_BEETROOT: "prized_beetroot",
        PRIZED_TURNIP: "prized_turnip",
        PINK_FLOWERS: "pink_flowers",
        PURPLE_FLOWERS: "purple_flowers",
        SLUG_BROTH: "slug_broth",
        SOCKS: "socks",
        SCENTED_SOAP: "scented_soap",
        SONG_SHEET: "song_sheet",
        SALAD: "salad",
        TREASURE: "treasure",
        TRUFFLE_OIL: "truffle_oil",
        TRUFFLE: "truffle",
        TURNIP_CUBES: "turnip_cubes",
        TURNIP_TOP: "turnip_top",
        TEA_CUP: "tea_cup",
        USELESS_GLASSES: "useless_glasses",
        VIAL_CENTICORE_TEARS_EMPTY: "vial_centicore_tears_empty",
        VIAL_CENTICORE_TEARS_FULL: "vial_centicore_tears_full"
    },

    ENEMY_ID: {
        BUTTERFLY: "butterfly",
        CHICKEN: "chicken",
        DRAGONFLY: "dragonfly",
        DUCKLING: "duckling",
        FIREFLY: "firefly",
        FLYING_SNAKE: "flying_snake",
        SIMON_SAYS: "simon_says",
        SNAPPER_PLANT: "snapper_plant",
        SPIDER: "spider",
        SPIKE_TRAP: "spike_trap"
    },

    BOSS_ID: {
        BATWITCH: "batwitch",
        CHICK_OF_DOOM: "chick_of_doom",
        GIANT_SPIDER: "giant_spider",
        GNOME_BEAR: "gnome_bear",
        SUZIE: "suzie"
    },

    BOSS_STATE: {
        IDLE: 0,
        TAKE_DAMAGE: 1,
        ATTACK: 2,
        DEAD: 3
    },

    ENEMY_STATE: {
        IDLE: 0,
        WANDER: 1,
        CHASE: 2,
        RETREAT: 3,
        ATTACK: 4,
        TAKE_DAMAGE: 5,
        DEAD: 6,
        CAPTURE: 7
    },

    ENEMY_TURNIP_DROP_CHANCE: 0.35,

    HUD_BUTTON_LAYOUT: {
        DEFAULT: 0,
        MINIGAME: 1,
        BOSS: 2
    },

    LEVEL_ID: {
        CASTLE_DUNGEON: "castle_dungeon",
        CASTLE_EXTERIOR: "castle_exterior",
        CAVE_HIDDEN_1: "cave_hidden_1",
        CAVE_HIDDEN_2: "cave_hidden_2",
        CAVE_HIDDEN_3: "cave_hidden_3",
        CAVE_HIDDEN_4: "cave_hidden_4",
        CAVE_HIDDEN_5: "cave_hidden_5",
        CAVE_HIDDEN_6: "cave_hidden_6",
        CAVE_MOLES: "cave_moles",
        FOREST_BOARIS_CAMP: "forest_boariscamp",
        FOREST_CLEARING: "forest_clearing",
        FOREST_DARK: "forest_dark",
        FOREST_LAKESIDE_EAST: "forest_lakeside_east",
        FOREST_LAKESIDE_WEST: "forest_lakeside_west",
        FOREST_MOLECAVE: "forest_molecave",
        FOREST_OUTLAWS: "forest_outlaws",
        FOREST_SWAMP: "boggy_swamp",
        GNOME_CLEARING: "gnome_clearing",
        KINGDOM_STAG: "kingdom_stag",
        ROCKY_MOUNTAIN: "rocky_mountain",
        SVAN_LAND: "svan_land",
        TUTORIAL: "tutorial",
        UNDERWATER_KINGDOM: "underwater_kingdom",
        VILLAGE_FARM: "village_farm",
    },

    LEVEL_SHORTCUT: {
        DEFAULT: "default",
        NORTH: "north",
        EAST: "east",
        SOUTH: "south",
        WEST: "west"
    },

    NPC_ID: {
        ALAN: "alan",
        ALLAN_THE_DWARF: "allan_the_dwarf",
        ARTHUR: "arthur",
        BOBBIN: "bobbin",
        BARRY: "barry",
        BOAR: "boar",
        BADGER: "badger",
        BARBARIAN: "barbarian",
        BAR_KEEP: "bar_keep",
        BATWITCH: "batwitch",
        BRIAN: "brian",
        BOARIS: "boaris",
        CHEF_SOW: "chef_sow",
        CHICK_OF_DOOM: "chick_of_doom",
        CEDRIC: "cedric",
        DAISY: "daisy",
        DUCKY: "ducky",
        DITZI: "ditzi",
        DWIGHT: "dwight",
        FISH_GUARD: "fish_guard",
        FOX_THIEF_1: "fox_thief_1",
        FOX_THIEF_2: "fox_thief_2",
        FOX_THIEF_3: "fox_thief_3",
        FRITZI: "fritzi",
        FERAL: "feral",
        GOBLIN: "goblin",
        GIANT_SPIDER: "giant_spider",
        GNOME_BEAR: "gnome_bear",
        GLITZI: "glitzi",
        GUNTHER: "gunther",
        HANSI: "hansi",
        HENCH_CAT_1: "hench_cat_1",
        HENCH_CAT_2: "hench_cat_2",
        MAGGIE: "maggie",
        MR_FAIRY: "mr_fairy",
        MOTHER_DUCK: "mother_duck",
        NANNY: "nanny",
        JEZABEL: "jezabel",
        KING_AXALOTYL: "king_axalotyl",
        KING_KNUT: "king_knut",
        KING_SVANSON: "king_svanson",
        LARS: "lars",
        LISBET: "lisbet",
        NOBLESWAN_1: "nobleswan_1",
        NOBLESWAN_2: "nobleswan_2",
        OSKAR: "oskar",
        PERCY: "percy",
        PONY_1: "pony_1",
        PONY_2: "pony_2",
        PONY_3: "pony_3",
        PRINCE_SVAN: "prince_svan",
        PRINCESS_SVANDELYNE: "princess_svandelyne",
        PRINCESS_SYLLABOB: "princess_syllabob",
        RAYMOND: "raymond",
        RULF: "rulf",
        ROGER: "roger",
        SPRITZI: "spritzi",
        SUZIE: "suzie",
        SUSAN: "susan",
        TATIANA: "tatiana",
        TOBY: "toby",
        QUEEN_GRIZBELLA: "queen_grizabella",
        QUEEN_KRISTINE: "queen_kristine",
        QUEEN_SVANIA: "queen_svania",
        WOLF: "wolf",
        WEASEL: "weasel"
    },

    NPC_STATUS_INDICATOR_STATE: {
        QUEST_NONE: 0,
        QUEST_AVAILABLE: 1,
        QUEST_IN_PROGRESS: 2,
        QUEST_REQUIREMENTS_MET: 3,
        QUEST_MINIGAME: 4,
        QUEST_BOSS_FIGHT: 5
    },

    PLAYER_ACTION: {
        ATTACK: 0,
        INTERACT: 1,
        TALK: 2
    },

    PLAYER_STANCE: {
        NORMAL: 0,
        COMBAT: 1,
        DEAD: 2
    },

    PLAYER_DAMAGE_EFFECT: {
        FAST: 0.34,
        SLOW: 0.8
    },

    QUEST_TYPE: {
        BOSS_FIGHT: "boss_fight",
        DUMMY: "dummy",
        FETCH: "fetch",
        FILL_COLLECTION_JAR: "fill_collection_jar",
        KILL: "kill",
        MINIGAME_BUTTERFLY_CATCH: "minigame_butterfly_catch",
        MINIGAME_CHICKEN_RUN: "minigame_chicken_run",
        MINIGAME_DUCKLING_TRAIN: "minigame_duckling_train",
        MINIGAME_SIMON_SAYS: "minigame_simon_says",
        MINIGAME_SNAKE_ATTACK: "minigame_snake_attack"
    },

    SCENE_LOADER_ASSET: {
        REQUIRED: 0,
        PERSISTENT: 1,
        TEMPORARY: 2
    },

    SHADOW_SIZE: {
        SMALL: 0,
        MEDIUM: 1,
        LARGE: 2,
        CUSTOM: 3
    },

    TEXT_FORMAT_VAR: {
        SCORE: "score",
        TARGET: "target"
    },

    TILEMAP_LAYER_TYPE: {
        TILE: "tilelayer",
        OBJECT: "objectgroup"
    },

    TILESET_FLIPPED_HORIZONTALLY_FLAG: 0x80000000,
    TILESET_FLIPPED_VERTICALLY_FLAG: 0x40000000,
    TILESET_FLIPPED_DIAGONALLY_FLAG: 0x20000000,
    TILESET_ROTATED_HEXAGONAL_120_FLAG: 0x10000000,

    TUTORIAL_STATE: {
        NONE: 0,
        MOVEMENT: 1,
        INTERACTION: 2
    },

    WORLD_LAYER_TYPE: {
        GAME: 0,
        SHADOW: 1
    },

    COLLISION_TYPE: {
        CIRCLE: 0,
        RECT: 1,
        POLYGON: 2
    },

    WEAPONS: {
        SWORD: "weapon_sword",
        MACE: "weapon_mace",
    },

    ATTIRE: {
        DEFAULT: "attire_default",
        NIGHTGOWN: "attire_nightgown"
    }
}